/** The five channels of an expense cut as lines in the Trace card (07.3 E10-E14); nothing renders for any other decision. */
import type { ChannelLine } from "./costCut";

export function CostCutChannels({ lines, decisionId }: { readonly lines: readonly ChannelLine[]; readonly decisionId: string }) {
  return <>{lines.map((c) => <div key={c.id} data-testid={`decide.trace.channel.${decisionId}.${c.id}`}><b>{c.label}.</b> {c.text}</div>)}</>;
}
